/**
 * Include your custom JavaScript here.
 * CheckoutGuard now handles all add-to-cart restrictions.
 */

(function() {

  /**
   * ISBN searches miss Shopify's text index. A bare ISBN-10 or ISBN-13
   * (hyphens and spaces allowed) is looked up on variant SKU and barcode.
   * Any other query, including recently viewed id: searches, is unchanged.
   */
  function wcsIsbnFilterQuery(raw) {
    if (!raw || /variants\.(sku|barcode):/i.test(raw)) return null;

    var parts = String(raw).split(/\s+AND\s+/i);
    var lastIndex = parts.length - 1;
    var last = parts[lastIndex].trim();
    var compact = last.replace(/[-\s]/g, '');

    if (!/^(\d{13}|\d{9}[\dXx])$/.test(compact)) return null;

    var isbn = compact.toUpperCase();
    parts[lastIndex] = 'variants.sku:' + isbn + ' OR variants.barcode:' + isbn;
    return parts.join(' AND ');
  }

  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (!form || !form.getAttribute) return;

    var action = form.getAttribute('action') || '';
    if (action.indexOf('/search') === -1) return;

    var input = form.querySelector('[name="q"]');
    if (!input) return;

    var rewritten = wcsIsbnFilterQuery(input.value);
    if (!rewritten) return;

    input.value = rewritten;
  }, true);

  if (window.fetch) {
    var wcsOriginalFetch = window.fetch.bind(window);

    window.fetch = function(input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url);

        if (url && url.indexOf('/search') !== -1 && (url.indexOf('/search/suggest') !== -1 || url.indexOf('section_id=predictive-search') !== -1)) {
          var parsed = new URL(url, window.location.origin);
          var rewritten = wcsIsbnFilterQuery(parsed.searchParams.get('q'));

          if (rewritten) {
            parsed.searchParams.set('q', rewritten);
            var next = parsed.pathname + parsed.search + parsed.hash;

            if (typeof input === 'string') {
              input = next;
            } else {
              input = new Request(next, input);
            }
          }
        }
      } catch (e) {}

      return wcsOriginalFetch(input, init);
    };
  }

  /**
   * SEO URL Cleaner
   * Strips tracking parameters from product links to ensure canonical URLs are used.
   * Addresses: pr_prod_strat, pr_rec_id, pr_rec_pid, pr_ref_pid, pr_seq (recommendations)
   *            _pos, _sid, _ss (search/filtering)
   */
  const SEO_URL_CLEANER = {
    // Parameters to remove from product URLs
    paramsToRemove: [
      'pr_prod_strat',
      'pr_rec_id',
      'pr_rec_pid',
      'pr_ref_pid',
      'pr_seq',
      '_pos',
      '_sid',
      '_fid',
      '_ss',
      '_psq',
      '_v'
    ],

    /**
     * Clean a single URL by removing tracking parameters
     * @param {string} href - The URL to clean
     * @returns {string} - The cleaned URL
     */
    cleanUrl: function(href) {
      if (!href || !href.includes('?')) return href;

      try {
        const url = new URL(href, window.location.origin);
        let hasParams = false;

        this.paramsToRemove.forEach(function(param) {
          if (url.searchParams.has(param)) {
            url.searchParams.delete(param);
            hasParams = true;
          }
        });

        // Return cleaned URL (without empty query string)
        if (hasParams) {
          return url.searchParams.toString() ? url.pathname + '?' + url.searchParams.toString() + url.hash : url.pathname + url.hash;
        }
      } catch (e) {
        // Invalid URL, return original
      }

      return href;
    },

    /**
     * Clean all product links within a container
     * @param {Element} container - The container to search within
     */
    cleanLinks: function(container) {
      const self = this;
      const productLinkSelector = 'a[href*="/products/"]';
      const links = container.querySelectorAll(productLinkSelector);

      links.forEach(function(link) {
        const originalHref = link.getAttribute('href');
        const cleanedHref = self.cleanUrl(originalHref);

        if (originalHref !== cleanedHref) {
          link.setAttribute('href', cleanedHref);
        }
      });
    },

    /**
     * Initialize the URL cleaner with MutationObserver for dynamic content
     */
    init: function() {
      var self = this;

      // Clean existing links on page load
      this.cleanLinks(document.body);

      // Debounced MutationObserver — batches rapid DOM mutations (e.g. mini-cart
      // re-render with 100+ items) into a single cleanup pass instead of
      // firing querySelectorAll per added node.
      var pendingContainers = [];
      var debounceTimer = null;

      function flushPending() {
        var containers = pendingContainers;
        pendingContainers = [];
        debounceTimer = null;
        for (var i = 0; i < containers.length; i++) {
          // Only clean if the node is still in the DOM
          if (containers[i].isConnected !== false) {
            self.cleanLinks(containers[i]);
          }
        }
      }

      var observer = new MutationObserver(function(mutations) {
        for (var m = 0; m < mutations.length; m++) {
          var addedNodes = mutations[m].addedNodes;
          for (var n = 0; n < addedNodes.length; n++) {
            if (addedNodes[n].nodeType === Node.ELEMENT_NODE) {
              pendingContainers.push(addedNodes[n]);
            }
          }
        }
        if (pendingContainers.length > 0 && !debounceTimer) {
          debounceTimer = setTimeout(flushPending, 150);
        }
      });

      // Only observe direct children of body (not deep subtree) — product links
      // are added as top-level section replacements, not deep nested insertions.
      // Falls back to subtree for safety.
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  };

  // Initialize SEO URL Cleaner when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      SEO_URL_CLEANER.init();
    });
  } else {
    SEO_URL_CLEANER.init();
  }

  // Polyfill for smooth scroll (if not supported)
  if (!('scrollBehavior' in document.documentElement.style)) {
    window.scrollTo = function(options) {
      window.scroll({
        top: options.top,
        left: options.left,
        behavior: 'auto' // Fallback for smooth scroll
      });
    };
  }

  // DOMContentLoaded extras
  document.addEventListener('DOMContentLoaded', function() {
    const featuredCollections = document.querySelectorAll("[data-featured-collection]");
    if (featuredCollections.length > 0) {
      const firstFeaturedCollection = featuredCollections[0]; // Get first section
      const images = firstFeaturedCollection.querySelectorAll(".js-product-image");

      images.forEach(function(image){
        image.setAttribute("loading", "eager");
      });
    }
  });

  // Auto-close mini-cart on scroll down (throttled to avoid firing 60×/sec)
  var lastScrollPosition = 0;
  var scrollThrottled = false;
  window.addEventListener('scroll', function () {
    if (scrollThrottled) return;
    scrollThrottled = true;
    setTimeout(function() { scrollThrottled = false; }, 200);

    var currentScrollPosition = window.scrollY;

    if (currentScrollPosition > lastScrollPosition && currentScrollPosition > 600) {
      var cartToggle = document.querySelector('.header__cart-toggle');

      if (cartToggle && cartToggle.getAttribute('aria-expanded') === 'true') {
        cartToggle.click();
      }
    }

    lastScrollPosition = currentScrollPosition;
  });

  /**
   * Fill “Last purchased on …” from the one-time JSON index in layout.
   * Avoids scanning customer.orders in Liquid on every product/cart line.
   */
  function wcsFillPurchaseHistory() {
    var dataEl = document.getElementById('wcs-purchase-history-data');
    if (!dataEl) return;

    var records;
    try {
      records = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!Array.isArray(records) || records.length === 0) return;

    function escapeHtml(value) {
      return String(value).replace(/[&<>"']/g, function(char) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
      });
    }

    // order.customer_url is an absolute https://…/account/orders/… URL.
    // A bare "#" with target="_blank" opens the current product page.
    function orderHref(url) {
      if (!url || typeof url !== 'string') return '';

      var path = '';
      if (url.charAt(0) === '/' && url.charAt(1) !== '/') {
        path = url;
      } else {
        try {
          var parsed = new URL(url);
          if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return '';
          path = parsed.pathname + parsed.search + parsed.hash;
        } catch (e) {
          return '';
        }
      }

      var pathname = path.split('?')[0].split('#')[0];
      if (!/^\/account\/orders\/[A-Za-z0-9_-]+\/?$/.test(pathname)) return '';
      return path;
    }

    var nodes = document.querySelectorAll('[data-wcs-purchase-history]:not([data-wcs-ph-done])');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      node.setAttribute('data-wcs-ph-done', 'true');

      var skus = (node.getAttribute('data-skus') || '').split(',').map(function(sku) {
        return sku.trim();
      }).filter(Boolean);
      var title = (node.getAttribute('data-title') || '').trim();
      var titleFallback = node.getAttribute('data-enable-title-fallback') !== 'false';
      var match = null;

      for (var r = 0; r < records.length; r++) {
        var rec = records[r];
        if (rec.s && skus.indexOf(rec.s) !== -1) {
          match = rec;
          break;
        }
        if (titleFallback && !rec.s && rec.t && rec.t === title) {
          match = rec;
          break;
        }
      }

      if (!match) {
        node.remove();
        continue;
      }

      var tag = node.getAttribute('data-as-small') === 'true' ? 'small' : 'span';
      var orderLabel = 'Order #' + escapeHtml(match.n);
      var href = orderHref(match.u);
      var orderHtml = href
        ? '(<a href="' + escapeHtml(href) + '" target="_blank" rel="noopener" class="link link--accented">' + orderLabel + '</a>)'
        : '(' + orderLabel + ')';
      var inner = 'Last purchased on ' + escapeHtml(match.d) + ' ' + orderHtml;
      inner = '<' + tag + ' class="purchased-before">' + inner + '</' + tag + '>';

      if (node.getAttribute('data-mode') === 'product_info') {
        node.innerHTML = '<span class="product-form__info-title text--strong">Purchase history</span>' +
          '<div class="product-form__info-content">' + inner + '</div>';
      } else if (node.getAttribute('data-mode') === 'bare') {
        node.outerHTML = inner;
        continue;
      } else {
        node.innerHTML = inner;
      }

      node.hidden = false;
    }
  }

  function wcsSchedulePurchaseHistory() {
    window.setTimeout(wcsFillPurchaseHistory, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wcsFillPurchaseHistory);
  } else {
    wcsFillPurchaseHistory();
  }
  document.documentElement.addEventListener('cart:refresh', wcsSchedulePurchaseHistory);
  document.addEventListener('shopify:section:load', wcsSchedulePurchaseHistory);

  var wcsPhObserverTimer = null;
  var wcsPhObserver = new MutationObserver(function() {
    if (wcsPhObserverTimer) return;
    wcsPhObserverTimer = window.setTimeout(function() {
      wcsPhObserverTimer = null;
      wcsFillPurchaseHistory();
    }, 150);
  });
  if (document.body) {
    wcsPhObserver.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      wcsPhObserver.observe(document.body, { childList: true, subtree: true });
    });
  }

// Single Issue Banner

  const allowedUrls = [
    "/pages/managecomics", // add more pages if you want to allow this to appear in other pages as well
  ];

  const currentPath = window.location.pathname;

  if (!allowedUrls.includes(currentPath)) return;

  const target = document.getElementById("managecomics");
  if (target) {
    const container = document.createElement("div");
    container.className = "single-issue-info-banner";

    const link = document.createElement("a");
    link.href = "/pages/walt-s-pullbox-easy-comic-book-pre-orders-subscriptions";
    link.className = "single-issue-info";
    link.textContent = "Please read this Info Page carefully before ordering with Manage Comics!";

    container.appendChild(link);
    target.parentNode.insertBefore(container, target);
  }

})();